(function() {
    'use strict';

    angular
        .module('telestatApp')
        .component('divisionsFilter', {
            templateUrl: 'app/components/divisions-filter/divisions-filter.template.html',
            controller: DivisionsFilterController,
            controllerAs: 'vm',
            bindings: {
                data: '='
            }
        });

    DivisionsFilterController.$inject = ['Principal', 'Division', '$translate'];

    function DivisionsFilterController (Principal, Division, $translate) {
        var vm = this;
        vm.search = search;
        vm.allDivisionsTranslate = $translate.instant('telestatApp.reportsCommon.allDivisions');

        if (Principal.hasAnyAuthority(['ROLE_ADMIN','ROLE_DIRECTOR','ROLE_CHECKER'])) {
            vm.data.division = {id:vm.data.pagingParams.divisionId};
            vm.data.divisions = [{id:null,actual:1,name: vm.allDivisionsTranslate}];
            vm.data.divisions[0].name = vm.allDivisionsTranslate;
            Division.getforselect({},function(data){
                vm.data.divisions = [{id:null,actual:1,name: vm.allDivisionsTranslate}].concat(makeFlatDivisionList(data, 0));
                // Найти и выставить имя для выбранного отдела, чтобы его можно было отобразить в заголовке страницы
                //data.forEach(function(d){if(d.id==vm.data.division.id){vm.data.division.name=d.name;}});
            });
        }
        function search() {
            vm.data.loadAll();
        }
        function makeFlatDivisionList(data, level) {
			var divFlatListArr = [];
			for (var i = 0; i < data.length; i++) {
				divFlatListArr.push({
					id : data[i].id,
					actual : true,
					name : ' - '.repeat(level) + data[i].name
				});
				if(data[i].id == vm.data.division.id){vm.data.division.name=data[i].name;}
				
				if (data[i].divisions !== undefined
						&& data[i].divisions.length > 0) {
					var t = makeFlatDivisionList(data[i].divisions, level + 1);
					divFlatListArr = divFlatListArr.concat(t);
				}
			}
			return divFlatListArr;
		}
    }


})();

